import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PickFaceStrategyList01Actions, {
  PickFaceStrategyList01Types
} from '../Stores/PickFaceStrategyList01/Actions';

const getAppStore = state => state.app;

export function* pickFaceStrategyList01FetchPickFaceStrategyList01({
  currentPage,
  sorts,
  filters,
  pageSize
}) {
  try {
    yield put(
      PickFaceStrategyList01Actions.pickFaceStrategyList01FetchPickFaceStrategyList01Loading(true)
    );

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `pickFaceStrategy/indexProcess/PICK_FACE_STRATEGY_LIST_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PickFaceStrategyList01Actions.pickFaceStrategyList01FetchPickFaceStrategyList01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PickFaceStrategyList01Actions.pickFaceStrategyList01FetchPickFaceStrategyList01Loading(false)
    );
  }
}

export function* pickFaceStrategyList01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/pickFaceStrategyDetail/update/${hdrId}`));
}

export function* pickFaceStrategyList01GoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PICK_FACE_STRATEGY/${hdrId}/PickFaceStrategy`));
}

export const saga = [
  takeLatest(
    PickFaceStrategyList01Types.PICK_FACE_STRATEGY_LIST01_GO_TO_AUDIT,
    pickFaceStrategyList01GoToAudit
  ),
  takeLatest(
    PickFaceStrategyList01Types.PICK_FACE_STRATEGY_LIST01_FETCH_PICK_FACE_STRATEGY_LIST01,
    pickFaceStrategyList01FetchPickFaceStrategyList01
  )
];
